import { ReactElement } from 'react';
import { MenuItem } from '@mui/material';
import { ValueLabel } from '..';
import { compose } from 'lodash/fp';
import { map, prop, sortBy } from 'rambda';

export const menuItems = compose(
  map<ValueLabel<string>, ReactElement>(({ value, label }) => (
    <MenuItem value={value} key={value}>
      {label}
    </MenuItem>
  ))
);

export const menuItemsSortByLabel = compose(menuItems, sortBy(prop('label')));
